import { ActionType, createReducer } from 'typesafe-actions';
import {
  PERFORM_UPLOAD_PHOTO,
  PUT_UPLOAD_PHOTO_RECORD,
  REMOVE_SELECTED_PHOTO,
  UploadPhotoCache,
} from '../actions/upload-photos';
import { SelectedPhoto } from '../types';

export type SelectedPhotosReducerActions =
  | ActionType<typeof PUT_UPLOAD_PHOTO_RECORD>
  | ActionType<typeof REMOVE_SELECTED_PHOTO>
  | ActionType<typeof PERFORM_UPLOAD_PHOTO.request>
  | ActionType<typeof PERFORM_UPLOAD_PHOTO.success>
  | ActionType<typeof PERFORM_UPLOAD_PHOTO.failure>
  | ActionType<typeof PERFORM_UPLOAD_PHOTO.cancel>;
export const selectedPhotosReducer = createReducer<SelectedPhoto[], SelectedPhotosReducerActions>([])
  .handleAction(PUT_UPLOAD_PHOTO_RECORD, (state, { payload }) => [...state, payload.uploadState])
  .handleAction(REMOVE_SELECTED_PHOTO, (state, { payload }) => {
    const result = [...state.filter((r) => r.uploadToken !== payload)];
    return result;
  })
  .handleAction([PERFORM_UPLOAD_PHOTO.request], (state, { payload }) => {
    let result = state;
    const recordIndex = state.findIndex((r) => r.uploadToken === payload.uploadToken);
    if (recordIndex > -1) {
      result = [
        ...state.slice(0, recordIndex),
        {
          ...state[recordIndex],
          isInProcessing: true,
          isUploaded: false,
          processingIsFailed: false,
          uploadedPhotoId: null,
        },
        ...state.slice(recordIndex + 1),
      ];
    }
    return result;
  })
  .handleAction([PERFORM_UPLOAD_PHOTO.success], (state, { payload }) => {
    let result = state;
    const recordIndex = state.findIndex((r) => r.uploadToken === payload.uploadToken);
    if (recordIndex > -1) {
      result = [
        ...state.slice(0, recordIndex),
        {
          ...state[recordIndex],
          isInProcessing: false,
          isUploaded: true,
          processingIsFailed: false,
          uploadedPhotoId: payload.photoId,
        },
        ...state.slice(recordIndex + 1),
      ];
    }
    return result;
  })
  .handleAction([PERFORM_UPLOAD_PHOTO.failure], (state, { payload }) => {
    let result = state;
    const recordIndex = state.findIndex((r) => r.uploadToken === payload.uploadToken);
    if (recordIndex > -1) {
      result = [
        ...state.slice(0, recordIndex),
        {
          ...state[recordIndex],
          isInProcessing: false,
          isUploaded: false,
          processingIsFailed: true,
          uploadedPhotoId: null,
        },
        ...state.slice(recordIndex + 1),
      ];
    }
    return result;
  })
  .handleAction(PERFORM_UPLOAD_PHOTO.cancel, (state, { payload }) => {
    let result = state;
    const recordIndex = state.findIndex((r) => r.uploadToken === payload);
    if (recordIndex > -1) {
      result = [
        ...state.slice(0, recordIndex),
        {
          ...state[recordIndex],
          isInProcessing: false,
          isUploaded: false,
          processingIsFailed: false,
          uploadedPhotoId: null,
        },
        ...state.slice(recordIndex + 1),
      ];
    }
    return result;
  });

export type UploadFilesCacheActions =
  | ActionType<typeof PERFORM_UPLOAD_PHOTO.request>
  | ActionType<typeof REMOVE_SELECTED_PHOTO>;
export const photoFilesCacheReducer = createReducer<UploadPhotoCache[], UploadFilesCacheActions>([])
  .handleAction(PERFORM_UPLOAD_PHOTO.request, (state, { payload }) => {
    let result = state;
    const recordIndex = state.findIndex((r) => r.uploadToken === payload.uploadToken);
    if (recordIndex === -1) {
      result = [
        ...state,
        {
          uploadToken: payload.uploadToken,
          file: payload.file,
        },
      ];
    }
    return result;
  })
  .handleAction(REMOVE_SELECTED_PHOTO, (state, { payload }) => {
    const result = [...state.filter((r) => r.uploadToken !== payload)];
    return result;
  });
